module.exports = __webpack_public_path__ + "img/logo_mes.3ef7e941.jpg";